<template>
  <div class="container wrapper">
    <CartList
      :products="order.products"
      :total-price="order.oldTotal ? +order.oldTotal : +order.totalPrice"
      :new-total="order.oldTotal ? +order.totalPrice : null"
      :show-buttons="false"
      :shipping="order.shipping"
      :add-shipping="addShipping"
      :on-shipping-change="onShippingChange"
    />

    <div class="customer-data">
      <p>{{ order.name }}</p>
      <p>{{ order.address }}</p>
      <p>{{ order.email }}</p>
      <p>{{ order.phone }}</p>
    </div>
    <button
      class="btn button-save"
      @click="finalizeOrder(true)"
    >
      {{ strings.summarise.pay_ }}
    </button>
    <button
      class="btn button-save"
      @click="finalizeOrder(false)"
    >
      {{ strings.summarise.payLater_ }}
    </button>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import CartList from '@/components/shop/CartProducts.vue'

export default {
  name: 'Summarise',
  components: {
    CartList
  },
  data () {
    return {
      addShipping: true
    }
  },
  computed: {
    ...mapGetters(['order', 'strings']),
    ...mapActions(['removeCart'])
  },
  mounted () {
    if (!this.order || Object.keys(this.order).length === 0) this.$router.push({ name: 'Cart' })
    if (this.order && this.order.payNow === false) this.$router.push({ name: 'OrderSuccess' })
  },
  methods: {
    onShippingChange () {
      this.addShipping = !this.addShipping
    },
    async finalizeOrder (payNow) {
      const order = { ...this.order }
      order.addShipping = this.addShipping

      delete order.paymentId
      delete order.realised
      delete order.totalPrice
      delete order.oldTotal
      delete order.__v
      delete order.timestamp
      delete order.shipping

      order.products = this.order.products.map(item => ({
        amount: item.amount,
        size: item.size,
        id: item.product._id
      }))
      try {
        const result = await this.$store.dispatch('finalizeOrder', { ...order, payNow })
        if (result.status === 201) {
          await this.removeCart
          if (payNow) {
            window.location.replace(result.data.paymentUrl)
          } else {
            window.location.reload()
          }
        } else if (result.status === 400) {
          this.$message(
            this,
            this.strings.summarise.errorTitle_,
            `${this.strings.summarise.error_}: ${result.data?.error?.message}`,
            'danger'
          )
        } else {
          this.$message(
            this,
            this.strings.summarise.errorTitle_,
            this.strings.summarise.error_,
            'danger'
          )
        }
      } catch (e) {
        this.$message(this,
          this.strings.summarise.errorTitle_,
          this.strings.summarise.error_,
          'danger')
      }
    }
  }
}
</script>

<style scoped lang="scss">
.wrapper {
  padding-top: 100px;
}
.customer-data {
  font-size: 1rem;
  letter-spacing: 2px;
  text-align: left;
  margin-bottom: 60px;
  margin-top: 60px;
}
.button-save {
  background-color: #000000;
  border: 1px solid #000000;
  border-radius: 0;
  color: #ffffff;
  padding: 10px 40px;
  margin-top: 10px;
  margin-bottom: 10px;
}

@media (min-width: 992px) {
  .wrapper {
    max-width: 800px;
  }
  .customer-data {
    font-size: 1.3rem;
    letter-spacing: 2px;
    text-align: left;
  }
  .button-save {
    margin-left: 2px;
    margin-right: 2px;
  }
}
</style>
